export default __webpack_public_path__ + "static/media/admin-gestao-paginas.15d1527b.svg";